const tryRequire = require('try-require')

module.exports = function (state, opts, config) {

    const ImageminPlugin = tryRequire('imagemin-webpack-plugin')
    const imageminMozjpeg = tryRequire('imagemin-mozjpeg')
    const imageminPngcrush = tryRequire('imagemin-pngcrush')

    if (!ImageminPlugin || !imageminMozjpeg || !imageminPngcrush) {
        return {} // waiting for an installation
    }

    // const FURTHER_REF = paths.FURTHER_REF
    return new ImageminPlugin({
        disable: !opts.development.optmizeImages && state.IS_DEV, // Disabled by default during development
        optipng: { optimizationLevel: 9 },
        gifsicle: { optimizationLevel: 3, interlaced: true },
        jpegtran: { optimizationLevel: 5 },
        svgo: { optimizationLevel: 5 },
        webp: { quality: 75 },
        pngquant: {
            quality: '65-90',
            speed: 4
        },
        plugins: [
            imageminMozjpeg({
                quality: 90
            }),
            imageminPngcrush(),
            // imageminWebp() // for some reason, this is corrupting jpg files :o
        ]  
    })
}



// WEBPACK FOOTER //
// ./src/technologies/optimize-images.js